module.exports = __webpack_public_path__ + "static/media/ali-yahya-2xWErKaRV38-unsplash.23f3c858.jpg";